/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation PlatformMailer($invoiceSmtpConfiguration: smtpConfigurationInput!) {
    PlatformMailer(invoiceSmtpConfiguration: $invoiceSmtpConfiguration) {
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
